import React, { useState, useCallback } from 'react'
import getThumbUri from '~data/modules/format/thumb'
import getScreenshotUri from '~data/modules/format/screenshot'
import getFaviconUri from '~data/modules/format/favicon'
import size from './size'
import { Preloader } from '~ui'

//cache thumb/screenshot uri
const thumbs = {}
const getUri = (uri, mode = '', domain) => {
    if (!thumbs[uri])
        switch (mode) {
            case 'screenshot':
                thumbs[uri] = getScreenshotUri(uri)
                break

            case 'favicon':
                thumbs[uri] = domain ? getFaviconUri(domain) : getThumbUri(uri)
                break

            default:
                thumbs[uri] = getThumbUri(uri)
                break
        }
    return thumbs[uri]
}

//pixel density
const dpr = {
    grid: (window.devicePixelRatio || 1) + 1,
    masonry: (window.devicePixelRatio || 1) + 1,
    default: window.devicePixelRatio || 1
}

//main component
const BookmarkItemCover = React.memo(function BookmarkItemCover({
    className = '',
    cover = '',
    link = '',
    domain,
    view = 'list',
    coverSize,
    indicator = false,
    ...etc
}) {
    const [loaded, setLoaded] = useState(() => (indicator ? false : true))

    const onImageLoadStart = useCallback(() => setLoaded(false), [])
    const onImageLoadSuccess = useCallback(() => setLoaded(true), [])

    const { width, height, ar } = size(view, coverSize) //use height only for img element
    let uri

    switch (view) {
        //simple always have a favicon
        case 'simple':
            if (link)
                uri = getUri(link, 'favicon', domain)
            break

        //in other view modes we show a thumbnail or screenshot
        default:
            if (cover && cover != '<screenshot>')
                uri = getUri(cover)
            else if (link)
                uri = getUri(link, 'screenshot')
            break
    }

    const mode = view == 'grid' ? 'fillmax' : 'crop'

    return (
        <picture
            role='img'
            className={'ui-bm-cover-wrap ui-bm-cover-' + view + ' ' + className}>
            <source
                srcSet={uri && `${uri}?mode=${mode}&fill=solid&format=webp&width=${width || ''}&ar=${ar || ''}&dpr=${dpr[view] || dpr.default}`}
                type='image/webp' />

            <img
                tabIndex='-1'
                className={'ui-bm-cover-image'}
                data-ar={ar}
                width={width}
                height={height}
                alt=' '
                {...etc}
                src={uri && `${uri}?mode=${mode}&fill=solid&width=${width || ''}&ar=${ar || ''}&dpr=${dpr[view] || dpr.default}`}
                //type='image/jpeg'
                onLoadStart={indicator ? onImageLoadStart : undefined}
                onLoad={indicator ? onImageLoadSuccess : undefined}
                onError={indicator && uri ? onImageLoadSuccess : undefined} />
            {!loaded && indicator && <div className={'ui-bm-cover-preloader'}><Preloader /></div>}
        </picture>
    )
})

export default BookmarkItemCover
